import { render } from "./ListElementsComponent.vue?vue&type=template&id=620a2dce"
import script from "./ListElementsComponent.vue?vue&type=script&lang=js"
export * from "./ListElementsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__